module.exports = __webpack_public_path__ + "static/media/a2.8556fae1.png";